module.exports = __webpack_public_path__ + "img/hp-knife-emerald.173b4437.png";